import { Elements, StripeProvider } from 'react-stripe-elements';
import CreditCardMain from './CreditCardMain';

const CreditCardWrapper = () => {
  return (
    <StripeProvider apiKey={process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY}>
      <Elements>
        <CreditCardMain />
      </Elements>
    </StripeProvider>
  );
};

export default CreditCardWrapper;
